import { useQuery } from "react-query";
import { getAdminPastAadeCases } from "src/aadeCase/data-access/gateway";
import { MRT_PaginationState } from "material-react-table";
import React from "react";

function useGetAdminPastAadeCases({
  searchFilters,
  enableSearch,
  setEnableSearch,
  paginationState,
}: {
  searchFilters: Object;
  enableSearch: Boolean;
  setEnableSearch: React.Dispatch<React.SetStateAction<Boolean>>;
  paginationState: MRT_PaginationState;
}) {
  return useQuery({
    queryFn: () => getAdminPastAadeCases(searchFilters, paginationState),
    queryKey: ["getAdminPastAadeCases", searchFilters, paginationState],
    onSettled: () => {
      setEnableSearch(false);
    },
    enabled: !!enableSearch,
  });
}

export default useGetAdminPastAadeCases;
